import { useInitializeMsTeams } from "PFCore/helpers/ms_teams";
import { PropsWithChildren } from "react";

export const MsTeamsInitializer = ({ children }: PropsWithChildren) => {
  const isMsTeamsInitialized = useInitializeMsTeams();

  return isMsTeamsInitialized ? children : null;
};
